import { render, staticRenderFns } from "./ThesisAdmin.vue?vue&type=template&id=9af8d876&scoped=true&"
import script from "./ThesisAdmin.vue?vue&type=script&lang=js&"
export * from "./ThesisAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ThesisAdmin.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ThesisAdmin.vue?vue&type=style&index=1&id=9af8d876&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9af8d876",
  null
  
)

export default component.exports